import { render, staticRenderFns } from "./MoleculeTheHeaderSubMenu.vue?vue&type=template&id=11863495&"
import script from "./MoleculeTheHeaderSubMenu.vue?vue&type=script&lang=js&"
export * from "./MoleculeTheHeaderSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports